import { useState, Children, cloneElement } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { PG, WHITE } from '@h2/components/colors'
import { Text } from '@h2/components/typography/text'

import { DropdownItem } from './dropdownItem'

const TextWrap = styled.div`
  display: flex;
  align-items: center;
`
const Arrow = styled.div`
  width: 6px;
  height: 6px;
  border-right: solid 1px ${WHITE};
  border-bottom: solid 1px ${WHITE};
  transform: rotate(45deg);
  margin-left: 7.5px;
`
const ItemsWrap = styled.ul`
  position: absolute;
  background-color: ${WHITE};
  border-radius: 1px;
  top: 27px;
  right: 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
  padding: 0;
  margin: 0;
  list-style-type: none;
`
const MainWrap = styled.div`
  position: relative;
  margin: ${({ margin }) => margin};
  padding: 6px 10px;
  background-color: ${PG};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  cursor: pointer;
`
const DropdownText = ({ children }) => (
  <TextWrap>
    <Text size="medium" color={WHITE} weight="bold" margin="0">
      {children}
    </Text>
    <Arrow />
  </TextWrap>
)
const Dropdown = ({ margin = '0', children }) => {
  const [expand, setExpand] = useState(false)
  const text = []
  const items = []

  Children.forEach(children, (child, index) => {
    child.type.displayName === 'DropdownText'
      ? text.push(child)
      : items.push(cloneElement(child, { key: index }))
  })

  return (
    <MainWrap
      margin={margin}
      onMouseEnter={() => setExpand(true)}
      onMouseLeave={() => setExpand(false)}>
      {text}

      {expand && <ItemsWrap>{items}</ItemsWrap>}
    </MainWrap>
  )
}

Dropdown.propTypes = {
  margin: PropTypes.string
}

DropdownText.displayName = 'DropdownText'
Dropdown.Item = DropdownItem
Dropdown.Text = DropdownText

export { Dropdown }
